import React, { useRef } from 'react';
var VeltNotificationsPanelContentForYou = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-for-you", { ref: ref }, children));
};
export default VeltNotificationsPanelContentForYou;
